import React from "react";
import moment from "moment";

var getFormattedMoment = function getFormattedMoment(theMoment, showTime) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var formatToUse = format; // If user specifies showTime and uses default format, render time

  if (showTime && format === "LL") {
    formatToUse = "LLL";
  }

  return theMoment.format(formatToUse);
};

var DateTime = function DateTime(_ref) {
  var _ref$currentTime = _ref.currentTime,
      currentTime = _ref$currentTime === void 0 ? new Date().toISOString() : _ref$currentTime,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "LL" : _ref$format,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "en" : _ref$lang,
      _ref$showTime = _ref.showTime,
      showTime = _ref$showTime === void 0 ? false : _ref$showTime,
      dateTime = _ref.dateTime,
      relative = _ref.relative;
  var theMoment = moment(dateTime);

  if (lang) {
    theMoment.locale(lang);
  }

  var content = getFormattedMoment(theMoment, showTime, format);

  if (relative) {
    content = theMoment.from(currentTime);
  }

  return /*#__PURE__*/React.createElement("time", {
    dateTime: dateTime
  }, content);
};

DateTime.displayName = "DateTime";
export default DateTime;